import { SxProp, View } from "dripsy";
import React from "react";
import { ProgressItem, ProgressStatus } from "./ProgressItem";

export interface UniProgressCardProps {
  statusData: Array<ProgressStatus>;
  sx?: SxProp;
}

export const UniProgressCard: React.FC<UniProgressCardProps> = (props) => {
  const { statusData, sx } = props;

  const parseStatusData = () => {
    if (!statusData) return [];
    return statusData.map((item, i) => {
      const prevStatus = statusData[i - 1]?.status || null;
      const nextStatus = statusData[i + 1]?.status || null;
      return { ...item, prevStatus, nextStatus };
    });
  };

  const parsedStatusData = parseStatusData();

  return (
    <View sx={{ ...progressCardSxStyles.container, ...sx }}>
      {parsedStatusData.map((status, index) => (
        <ProgressItem {...status} index={index} key={index} />
      ))}
    </View>
  );
};

const progressCardSxStyles: Record<string, SxProp> = {
  container: {},
};
